<ng-template [ngIf]="avanceSelect && avanceSelect.meta">
  <mat-toolbar class="dialog-title">
    <span>Avance</span>
    <div (click)="cerrar()" class="close-dialog">
      <i class="fas fa-times"></i>
    </div>
  </mat-toolbar>
  <div mat-dialog-content>

    <div *ngIf="objetivosMultiLevelList.length>0">
      <div *ngFor="let confPlan of objetivosMultiLevelList;let i = index">
        <mat-form-field appearance="outline" style="display: block; ">
          <mat-label>{{confPlan.nombre}}</mat-label>
          <mat-select (selectionChange)="seleccionarObjetivo($event,i)">
            <mat-option></mat-option>
            <mat-option *ngFor="let objetivo of confPlan.objetivos" [value]="objetivo">
              {{objetivo.nombre?objetivo.nombre:objetivo.codigo}}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div>

    <mat-form-field appearance="outline" class="field-meta-100">
      <mat-label>Indicador</mat-label>
      <textarea matInput [(ngModel)]="avanceSelect.meta.descripcion" matTextareaAutosize matAutosizeMinRows=2 matAutosizeMaxRows=5 readonly="true"></textarea>
    </mat-form-field>

    <mat-form-field appearance="outline" class="field-meta-100">
      <mat-label>Fecha de Avance<span style="color: red;">*</span></mat-label>
      <input matInput [matDatepicker]="picker" [(ngModel)]="avanceSelect.fechaAvance" required>
      <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
      <mat-datepicker #picker></mat-datepicker>
    </mat-form-field>

    <mat-form-field appearance="outline" class="field-meta-100">
      <mat-label>Descripción<span style="color: red;">*</span></mat-label>
      <textarea matInput [(ngModel)]="avanceSelect.descripcion" matTextareaAutosize matAutosizeMinRows=2 matAutosizeMaxRows=7 required></textarea>
    </mat-form-field>

    <mat-form-field *ngIf="avanceSelect.meta.contieneLengua && avanceSelect.lengua" appearance="outline" class="field-meta-50">
      <mat-label>Lengua</mat-label>
      <mat-select  (selectionChange)="listarVarianteLenguas($event)" [(ngModel)]="avanceSelect.lengua.id">
        <mat-option></mat-option>
        <mat-option *ngFor="let lengua of lenguaList" [value]="lengua.id">
          {{lengua.nombre}}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field *ngIf="avanceSelect.meta.contieneLengua && avanceSelect.varianteLengua" appearance="outline" class="field-meta-50">
      <mat-label>Variante Lengua</mat-label>
      <mat-select [(ngModel)]="avanceSelect.varianteLengua.id">
        <mat-option></mat-option>
        <mat-option *ngFor="let variante of varianteLenguaList" [value]="variante.id">
          {{variante.nombre}}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <div style="width: 100%;">
      <mat-form-field appearance="outline" class="field-meta-30">
        <mat-label>Región</mat-label>
        <mat-select [compareWith]="compararUbigeo" (selectionChange)="listarProvinciasSegunIdRegion($event)" [(ngModel)]="avanceSelect.ubigeoRegion">
          <mat-option></mat-option>
          <mat-option *ngFor="let region of regionesList" [value]="region">
            {{region.nombreUbigeo}}
          </mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field appearance="outline" class="field-meta-30">
        <mat-label>Provincía</mat-label>
        <mat-select [compareWith]="compararUbigeo" (selectionChange)="listarDistritosSegunIdProvincia($event)" [(ngModel)]="avanceSelect.ubigeoProvincia">
          <mat-option></mat-option>
          <mat-option *ngFor="let provincia of provinciasList" [value]="provincia">
            {{provincia.nombreUbigeo}}
          </mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field appearance="outline" class="field-meta-30">
        <mat-label>Distrito</mat-label>
        <mat-select [compareWith]="compararUbigeo" [(ngModel)]="avanceSelect.ubigeoDistrito">
          <mat-option></mat-option>
          <mat-option *ngFor="let distrito of distritoList" [value]="distrito">
            {{distrito.nombreUbigeo}}
          </mat-option>
        </mat-select>
      </mat-form-field>
      <ng-template [ngIf] = "variablePorMeta">      
        <mat-label class="custom-label">Variables</mat-label>
        <div style="padding:15px;padding-bottom: 0px; margin-bottom: 6px;margin-top:3px ;border: 0.5px solid rgb(224,224,224); border-radius:5px;">
              <div *ngFor="let variable of variablePorMeta" style="padding:5px">
                <div class="custom-label" style="padding:3px;padding-bottom:6px;text-align: justify;font-weight: normal !important;">{{variable.nombre}}</div>
              <mat-form-field *ngIf="variable.tipoDato == constantes.TIPO_DATO_NUMERO" appearance="outline" style="width:100%;">
                <mat-label>Ingrese número</mat-label>
                <input matInput [(ngModel)]="variable.valorVariableAvance.valor" type="number" min="0">
              </mat-form-field>
              <mat-form-field *ngIf="variable.tipoDato == constantes.TIPO_DATO_TEXTO" appearance="outline" style="width:100%;">
                <mat-label>Ingrese texto</mat-label>
                <textarea matInput [(ngModel)]="variable.valorVariableAvance.valor" matTextareaAutosize matAutosizeMinRows=2 matAutosizeMaxRows=7></textarea>
              </mat-form-field>
              <mat-form-field *ngIf="variable.tipoDato == constantes.TIPO_DATO_FECHA" appearance="outline" style="width:100%;">
                <mat-label>Ingrese fecha</mat-label>
                <input matInput [matDatepicker]="picker" [(ngModel)]="variable.valorVariableAvance.valor">
                <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                <mat-datepicker #picker></mat-datepicker>
              </mat-form-field>
              <mat-form-field *ngIf="variable.tipoDato == constantes.TIPO_DATO_LISTA" appearance="outline" style="width:100%;">
                <mat-label>Seleccione</mat-label>
                <mat-select [(ngModel)]="variable.valorVariableAvance.valor">
                  <mat-option></mat-option>
                  <mat-option *ngFor="let config of variable.valoresListaArray" [value]="config">
                    {{config}}
                  </mat-option>
                </mat-select>
              </mat-form-field>
              <div *ngIf="variable.tipoDato == constantes.TIPO_DATO_LISTA_MULTIPLE">
                <mat-selection-list [(ngModel)]="variable.valoresListaSeleccionados">
                  <mat-list-option *ngFor="let valor of variable.valoresListaArray" [value]="valor">
                    {{valor}}
                  </mat-list-option>
                </mat-selection-list>
              </div>
              <div *ngIf="variable.tipoDato == constantes.TIPO_DATO_VERDADERO_FALSO" style="padding:8px;border: 0.5px solid rgb(224,224,224); border-radius:5px;;margin-bottom: 17px;">
                <mat-radio-group id="valorVariable-{{variable.valorVariableAvance.id}}" aria-label="Select an option" style="margin-right: 10px;" [(ngModel)]="variable.valorVariableAvance.valor">
                  <mat-radio-button value="Si">Si</mat-radio-button>
                  <mat-radio-button style="padding-left: 10px;" value="No">No</mat-radio-button>
                </mat-radio-group>
              </div>
        </div>
        </div>
      </ng-template>
      <br>
      <button mat-raised-button type="button" md-button style="display: block;margin-bottom: 10px;" (click)="imgFileInput.click()">Adjuntar archivo</button>
      <input hidden type="file" #imgFileInput (change)="cargarArchivo($event)" />
      <div style="min-height: 100px; height: auto;border: 1px solid  #E0E0E0;padding:7px; margin-bottom: 10px;">
        <div *ngFor="let selected of avanceSelect.archivosList;let index = index" style="display: block;margin-bottom: 7px;">
          <span style="float:left; text-decoration: underline; cursor: pointer;width: 308px; white-space: nowrap;text-overflow: ellipsis;overflow: hidden;" (click)="descargarArchivoSeleccionado(selected)">{{selected.nombre}}</span>
          <span *ngIf="selected.tamanio" style="margin-left: 5px">{{selected.tamanio}}</span>
          <div *ngIf="!selected.tamanio" style="width: 5px"></div>
          <button style="float: right;" mat-raised-button class="btn_danger" (click)="eliminarArchivoSeleccionado(index,selected)"><i title="Eliminar" class="fas fa-trash-alt"></i></button><br>
        </div>
      </div>
    </div>
    <div class="dialog-buttons">
      <button [disabled]="validarCampos()" mat-raised-button class="btn_olive" (click)="guardarAvance()">Registrar</button>&nbsp;
      <button mat-raised-button class="btn_danger" (click)="cerrar()">Cancelar</button>
    </div>
  </div>
</ng-template>
